import { Input } from '@material-tailwind/react'
import { formatRut } from 'react-rut-formatter'

export const DocumentNumberInput = ({ value, onChange, ...props }) => {
  const handleChileanRutChange = (e) => {
    e.target.value = formatRut(e.target.value)
    onChange(e)
  }

  return (
    <Input onChange={handleChileanRutChange} maxLength={10} value={value}
      {...props}
    />
  )
}
